export const toSurveyRoot = pathname => {
  const root = pathname.match(/\/organisationSurvey\/\w+/)[0]
  return root
}

export const toStart = path => `${toSurveyRoot(path)}/start`
export const toSubmission = path => `${toSurveyRoot(path)}/submit`
